<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-10 11:40:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-10 11:40:00
 * @FilePath: \goodmanger\src\views\OrderManagement.vue
 * @Description: 订单管理页面
-->
<template>
  <div class="order-management">
    <div class="page-header">
      <h2>订单管理</h2>
    </div>
    
    <div class="search-box">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="订单编号">
          <el-input v-model="searchForm.orderId" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input v-model="searchForm.userName" placeholder="请输入用户名称"></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.status" placeholder="请选择订单状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待支付" value="pending"></el-option>
            <el-option label="已支付" value="paid"></el-option>
            <el-option label="已发货" value="shipped"></el-option>
            <el-option label="已完成" value="completed"></el-option>
            <el-option label="已取消" value="cancelled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <el-table :data="orderList" style="width: 100%">
      <el-table-column prop="orderId" label="订单编号" width="180"></el-table-column>
      <el-table-column prop="userName" label="用户名称" width="120"></el-table-column>
      <el-table-column prop="totalPrice" label="订单金额" width="120"></el-table-column>
      <el-table-column prop="orderTime" label="下单时间" width="180"></el-table-column>
      <el-table-column prop="status" label="订单状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="paymentMethod" label="支付方式" width="120"></el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleViewOrder(scope.row)">查看详情</el-button>
          <el-button v-if="scope.row.status === 'pending'" type="success" size="small" @click="handleUpdateStatus(scope.row, 'paid')">确认支付</el-button>
          <el-button v-else-if="scope.row.status === 'paid'" type="success" size="small" @click="handleUpdateStatus(scope.row, 'shipped')">确认发货</el-button>
          <el-button v-else-if="scope.row.status === 'shipped'" type="success" size="small" @click="handleUpdateStatus(scope.row, 'completed')">确认完成</el-button>
          <!-- <el-button v-if="scope.row.status === 'pending'" type="danger" size="small" @click="handleUpdateStatus(scope.row, 'cancelled')">取消订单</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 订单详情对话框 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible"
      width="700px">
      <div v-if="currentOrder" class="order-detail">
        <div class="order-info">
          <h3>订单信息</h3>
          <el-descriptions :column="3" border>
            <el-descriptions-item label="订单编号">{{ currentOrder.orderId }}</el-descriptions-item>
            <el-descriptions-item label="用户名称">{{ currentOrder.userName }}</el-descriptions-item>
            <el-descriptions-item label="订单金额">{{ currentOrder.totalPrice }} 元</el-descriptions-item>
            <el-descriptions-item label="下单时间">{{ currentOrder.orderTime }}</el-descriptions-item>
            <el-descriptions-item label="订单状态">{{ getStatusText(currentOrder.status) }}</el-descriptions-item>
            <el-descriptions-item label="支付方式">{{ currentOrder.paymentMethod }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <div class="order-items">
          <h3>商品信息</h3>
          <el-table :data="currentOrder.items" style="width: 100%">
            <el-table-column prop="name" label="商品名称"></el-table-column>
            <el-table-column prop="price" label="价格" width="100"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
            <el-table-column prop="subtotal" label="小计" width="100"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OrderManagement',
  data() {
    return {
      activeMenu: '/order-management',
      searchForm: {
        orderId: '',
        userName: '',
        status: ''
      },
      orderList: [
        {
          orderId: 'ORD20260210001',
          userName: '张三',
          totalPrice: 6999,
          orderTime: '2026-02-10 10:30:00',
          status: 'pending',
          paymentMethod: '微信支付',
          items: [
            {
              name: 'iPhone 15',
              price: 6999,
              quantity: 1,
              subtotal: 6999
            }
          ]
        },
        {
          orderId: 'ORD20260210002',
          userName: '李四',
          totalPrice: 13898,
          orderTime: '2026-02-10 11:15:00',
          status: 'paid',
          paymentMethod: '支付宝',
          items: [
            {
              name: 'MacBook Pro',
              price: 12999,
              quantity: 1,
              subtotal: 12999
            },
            {
              name: 'iPhone 15',
              price: 6999,
              quantity: 1,
              subtotal: 6999
            }
          ]
        },
        {
          orderId: 'ORD20260210003',
          userName: '王五',
          totalPrice: 899,
          orderTime: '2026-02-10 09:45:00',
          status: 'shipped',
          paymentMethod: '微信支付',
          items: [
            {
              name: 'Nike Air Max',
              price: 899,
              quantity: 1,
              subtotal: 899
            }
          ]
        },
        {
          orderId: 'ORD20260210004',
          userName: '赵六',
          totalPrice: 1798,
          orderTime: '2026-02-09 16:30:00',
          status: 'completed',
          paymentMethod: '支付宝',
          items: [
            {
              name: 'Nike Air Max',
              price: 899,
              quantity: 2,
              subtotal: 1798
            }
          ]
        }
      ],
      currentPage: 1,
      pageSize: 10,
      total: 4,
      dialogVisible: false,
      currentOrder: null
    };
  },
  methods: {
    handleSearch() {
      // 搜索逻辑
      console.log('搜索订单:', this.searchForm);
    },
    resetForm() {
      this.searchForm = {
        orderId: '',
        userName: '',
        status: ''
      };
    },
    handleSizeChange(size) {
      this.pageSize = size;
      console.log(`每页 ${size} 条`);
    },
    handleCurrentChange(current) {
      this.currentPage = current;
      console.log(`当前页: ${current}`);
    },
    handleViewOrder(row) {
      this.currentOrder = { ...row };
      this.dialogVisible = true;
    },
    handleUpdateStatus(row, status) {
      const statusText = this.getStatusText(status);
      this.$confirm(`确定要将订单状态更新为${statusText}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 更新状态逻辑
        const index = this.orderList.findIndex(item => item.orderId === row.orderId);
        if (index !== -1) {
          this.orderList[index].status = status;
        }
        this.$message({ type: 'success', message: '状态更新成功' });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    getStatusType(status) {
      switch (status) {
        case 'pending': return 'warning';
        case 'paid': return 'primary';
        case 'shipped': return 'info';
        case 'completed': return 'success';
        case 'cancelled': return 'danger';
        default: return '';
      }
    },
    getStatusText(status) {
      switch (status) {
        case 'pending': return '待支付';
        case 'paid': return '已支付';
        case 'shipped': return '已发货';
        case 'completed': return '已完成';
        case 'cancelled': return '已取消';
        default: return '';
      }
    }
  }
}
</script>

<style scoped>
.order-management {
  padding: 20px;
  background-color: #f5f5f5;
  height: 100%;
  overflow-y: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.search-box {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.el-table {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.order-detail {
  padding: 10px 0;
}

.order-info {
  margin-bottom: 20px;
}

.order-info h3,
.order-items h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: bold;
}

.order-items {
  margin-top: 20px;
}
</style>